import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { Staff } from '@/types/settings-api';

/**
 * Fetch a staff record for the edit dialog (PROD-765).
 *   GET /api/Staff/StaffSetupDetails/{staffSetupId}
 *
 * Flutter parity: `fetchStaffById` in `settings_data_source_impl.dart:896`.
 * The list endpoint (`/api/Staff/StaffList`) returns a leaner `StaffListItem`;
 * the edit form needs the full record (mobileNumber, specialities,
 * assignStaffToPractice) which only this endpoint carries.
 */
export function useStaffById(staffSetupId: string | null | undefined) {
  return useQuery({
    queryKey: ['settings', 'staff-by-id', staffSetupId],
    queryFn: ({ signal }) => {
      if (!staffSetupId) throw new Error('useStaffById called without id');
      return get<Staff>(
        `/api/Staff/StaffSetupDetails/${staffSetupId}`,
        { signal },
      );
    },
    enabled: !!staffSetupId,
  });
}
